import { Box, Typography } from '@mui/material'

export default function ErrorMessage() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '80vh',
      }}
    >
      <Typography variant="h6" gutterBottom>
        App not loading
      </Typography>
      <Typography variant="body1">Try again later</Typography>
    </Box>
  )
}
